/* tslint:disable */
/* eslint-disable */
/**
 * Amplified Intelligence - Account Manager API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../runtime';
import type { AccessLevelType } from './AccessLevelType';
import {
    AccessLevelTypeFromJSON,
    AccessLevelTypeFromJSONTyped,
    AccessLevelTypeToJSON,
} from './AccessLevelType';

/**
 *
 * @export
 * @interface InviteExistingUserDto
 */
export interface InviteExistingUserDto {
    /**
     *
     * @type {string}
     * @memberof InviteExistingUserDto
     */
    emailAddress?: string | null;
    /**
     *
     * @type {AccessLevelType}
     * @memberof InviteExistingUserDto
     */
    accessLevel?: AccessLevelType;
}

/**
 * Check if a given object implements the InviteExistingUserDto interface.
 */
export function instanceOfInviteExistingUserDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InviteExistingUserDtoFromJSON(json: any): InviteExistingUserDto {
    return InviteExistingUserDtoFromJSONTyped(json, false);
}

export function InviteExistingUserDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): InviteExistingUserDto {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        emailAddress: !exists(json, 'email_address') ? undefined : json['email_address'],
        accessLevel: !exists(json, 'access_level')
            ? undefined
            : AccessLevelTypeFromJSON(json['access_level']),
    };
}

export function InviteExistingUserDtoToJSON(value?: InviteExistingUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        email_address: value.emailAddress,
        access_level: AccessLevelTypeToJSON(value.accessLevel),
    };
}
